import _ from 'lodash';

const useDebounced = (getData: any, delay: number) => {
  return _.debounce(getData, delay);
};

export default useDebounced;
